import { withStyles, Typography, Button, IconButton } from '@material-ui/core';
import CloseIcon from 'src/assets/icons/common/CloseIcon';
import Link from 'next/link';
import { MobileTypography } from 'src/mobile/Typography';
import { useDispatch } from 'react-redux';
import { setActiveModel } from 'src/store/reducer';
import { Category } from 'src/types/model.types';

export const NavTypography = withStyles(() => ({
    root: { fontWeight: 500 }
}))((props) => <Typography variant="body2" {...props} />);

export const MobileNavTypography = withStyles(() => ({
    root: { fontWeight: 500, textAlign: 'right' }
}))((props: any) => <MobileTypography variant="h4" {...props} />);

export const NavButton = withStyles((theme) => ({
    root: {
        margin: `${theme.spacing(2)}px 1vw`,
        borderRadius: 0,
        padding: 0,
        color: '#FFF',
        '&:hover': {
            color: theme.palette.primary.main
        }
    }
}))(Button);

export const SidebarButtons = withStyles((theme) => ({
    root: {
        marginLeft: theme.spacing(4),
        marginTop: theme.spacing(1),
        borderRadius: 0,
        minWidth: 0,
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
            marginTop: 0
        }
    }
}))(Button);

export const MobileSidebarButtons = withStyles(() => ({
    root: {
        // marginLeft: theme.spacing(4),
        // marginTop: theme.spacing(1),
        borderRadius: 0,
        minWidth: 0
    }
}))(Button);

const CloseIconButton = withStyles({
    root: { alignSelf: 'flex-end' }
})(IconButton);
const RightCloseIconButton = withStyles({
    root: { alignSelf: 'flex-start' }
})(IconButton);

export const CloseButton = ({
    handleClose,
    className
}: {
    handleClose: () => void;
    className?: string;
}) => {
    return (
        <CloseIconButton onClick={handleClose} className={className}>
            <CloseIcon mdIcon />
        </CloseIconButton>
    );
};
export const RightCloseButton = ({
    handleClose,
    className
}: {
    handleClose: () => void;
    className?: string;
}) => {
    return (
        <RightCloseIconButton onClick={handleClose} className={className}>
            <CloseIcon mdIcon />
        </RightCloseIconButton>
    );
};

export const NavbarLink = ({ href, children }: AppCommonChild & { href: string }) => {
    return (
        <Link href={href}>
            <a>
                <SidebarButtons>{children}</SidebarButtons>
            </a>
        </Link>
    );
};
export const AppmodelNavbarLink = ({ model, children }: AppCommonChild & { model: Category }) => {
    const dispatch = useDispatch();
    return (
        <Link href={`/app-models`}>
            <a>
                <SidebarButtons
                    onClick={() => {
                        dispatch(setActiveModel({ model }));
                    }}>
                    {children}
                </SidebarButtons>
            </a>
        </Link>
    );
};
